import en from "../_translation/en/translation.json";
import ja from "../_translation/ja/translation.json";
import ko from "../_translation/ko/translation.json";

export function getLocalResource(value) {
    switch (value) {
        case "ko":
            return ko;
        case "en":
            return en;
        case "ja":
            return ja;
        default:
            return en;
    }
}

export function getLocalLngList(defaultLanguageCode) {
    const locales = [
        {
            id: 1,
            label: "English",
            value: "en",
            isDefault: 1,
        },
        {
            id: 2,
            label: "한국어",
            value: "ko",
            isDefault: 0,
        },
        {
            id: 3,
            label: "日本語",
            value: "ja",
            isDefault: 0,
        },
    ];

    return {
        locales,
        translation: getLocalResource(defaultLanguageCode),
    };
}

export function getDefaultLanguage() {
    return "en";
}

export function getLocalLng(code) {
    return getLocalResource(code);
}
